import React from 'react'
import './Chamber.css'

function Chamber() {
  return (
    <div className="main-chamber-container">
      {/* Hero section with background image and overlay */}
      <div className="chamber-hero">
        <div className="chamber-overlay">
          <h1>Chamber</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Content section with LCCI information */}
      <div className="chamber-content">
        <h2>The Lahore Chamber of Commerce & Industry</h2>
        <p className="chamber-highlight">Centrex Marine Services is a proud member of The Lahore Chamber of Commerce & Industry.</p>
        
        <div className="chamber-section">
          <h3>Our Vision</h3>
          <p>To be the best Chamber in SAARC Countries through growth in business volumes, turnovers, exports and contribution in tax revenues.</p>
        </div>
        
        <div className="chamber-section">
          <h3>Our Mission</h3>
          <ul>
            <li>To be the finest organization to serve the business community and to conduct its practices in best possible professional manner.</li>
            <li>To be a bridge between the Business Community and Regulatory Bodies for policy advocacy.</li>
            <li>To seek long term relations with members reflecting fairness, honesty and transparency.</li>
            <li>To build good repute of the Organization and maintaining high professional and ethical standards.</li>
            <li>To conduct Business with integrity and strive to be a top Chamber in the Region.</li>
          </ul>
        </div>
        
        <div className="chamber-section">
          <h3>Our Values</h3>
          <ul>
            <li>Respect – Treating all well and work with courtesy and respect, the way you want to be treated.</li>
            <li>Empathy – Listening and understanding the feelings and ideas of others.</li>
            <li>Shared Responsibility – Taking ownership and working as a team through collaboration among all stakeholders.</li>
            <li>Consistency – Being consistent in mastering and maintaining standards in services and overall the image of the institution.</li>
            <li>Innovation – Constant creativity in Research, Development and services for value addition and exceeding expectations of members, stakeholders and employees.</li>
          </ul>
        </div>
        
        <div className="chamber-link">
          <a href="https://lcci.com.pk" target="_blank" rel="noopener noreferrer">
            Visit LCCI Official Website
          </a>
        </div>
      </div>
    </div>
  )
}

export default Chamber
